import Immutable from 'seamless-immutable';
// ---- external imports ----

import * as types from './actionTypes';
// ---- local imports ----

const initialState = Immutable({
	name: '',
	rent: null,
	capacity: null,
	location: null
});

export default function reduce(state = initialState, action = {}) {
	switch (action.type) {
	case types.STORE_SET_NAME:
		return state.merge({
			name: action.storeName
		});
		case types.STORE_SELECTED:
		return state.merge({
			store: action.store,
			lastUpdate: Date.now()
		});
	case types.STORE_LOADED:
		return state.merge({
			...action.store
		});
	default:
		return state;
	}
}
